import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import ContactTagAppliedForm from './ContactTagAppliedForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(ContactTagAppliedForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactTagApplied/ContactTagAppliedForm.container.js